import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import Vimeo from "@u-wave/react-vimeo";
import videos from "../../../../services/videos";
import { ModalContainer } from "../../../modal/styled";
import { CloseOutlined } from "@ant-design/icons";
import ModelWrapper from "../../../modal/ModelWrapper";

const VideoPreviewModal = ({
  isVisible,
  setIsVisible,
  onClose,
  videoUrl,
  title,
}) => {
  const [videIframe, setVideoIframe] = useState(null);
  const [isError, setIsError] = useState(false);

  const getVideoUrl = async () => {
    try {
      const res = await videos.getVideoById({ url: videoUrl });
      setVideoIframe(res?.data?.video?.player_embed_url);
    } catch (error) {}
  };

  useEffect(() => {
    if (videoUrl) {
      getVideoUrl();
    }
  }, [videoUrl]);

  return (
    <ModelWrapper
      title={
        title && (
            
          <div
            className="font-18 font-semibold text-primary mb-5 ellipsis"
            style={{width: "95%"}}
            //   <h3 className="">
            //   Update Library Manager
            // </h3>
            // style={{ padding: "15px",fontSize:'18px',fontWeight:600 }}
          >
            {title.charAt(0).toUpperCase() + title.slice(1)}

            <span
              style={{
                position: "absolute",
                left: "95%",
                cursor: "pointer",
                color: "var(--primary-text-color)",
              }}
            >
              <CloseOutlined onClick={() => setIsVisible(false)} />
            </span>
          </div>
        )
      }
      show={isVisible}
      setShow={setIsVisible}
      onCancel={onClose}
      width={800}
      footer={null}
      centered
      destroyOnClose
    >
      {videIframe ? (
        <div
          style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}
        >
          {isError ? (
            <div>Video is prepraing</div>
          ) : (
            <Vimeo
              video={videIframe}
              autoplay={false}
              showTitle={false}
              showByline={false}
              showPortrait={false}
              responsive={true}
              onError={(error) => setIsError(true)}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
            />
          )}
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "40px" }}>
          {/* Invalid video URL */}
          Fetching Video ...
        </div>
      )}
    </ModelWrapper>
  );
};

export default VideoPreviewModal;
